import { getPlanList } from '@/api/carResource/index'
import { operateMaxShowLength } from '@/store/dict/config'

// 融租配置
export function financialLeaseConfigFn() {
  const ref = 'financialBaseListManagement'
  return {
    formData: {
      list: [{
        itemConfig: {
          prop: 'brandSeriesModel',
        },
        elConfig: {
          showModel: true,
        },
        render: 'CarBrandSeriesModel',
      }, {
        el: 'select',
        itemConfig: {
          label: '交车城市',
          prop: 'transactionCity',
        },
        elConfig: {
          clearable: true,
          options: {
            label: 'city',
            value: 'adcode',
            list: [],
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '金融机构',
          prop: 'financialInstitution',
        },
        elConfig: {
          clearable: true,
          options: {
            label: 'label',
            value: 'value',
            list: [],
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '租赁模式',
          prop: 'leaseModel',
        },
        elConfig: {
          clearable: true,
          options: {
            label: 'label',
            value: 'value',
            list: [],
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '还款方式',
          prop: 'repaymentMethod',
        },
        elConfig: {
          clearable: true,
          options: {
            label: 'label',
            value: 'value',
            list: [],
          },
        },
      }],
      dealWithSearch: this.dealWithSearch,
      customizeReset: this.financialReset,
    },
    tableData: {
      columns: [{
        name: 'id',
        columnProps: {
          prop: 'id',
          label: '方案ID',
        },
      }, {
        name: 'title',
        columnProps: {
          prop: 'title',
          label: '方案名称',
          width: '160px',
        },
      }, {
        name: 'brandName',
        columnProps: {
          prop: 'brandName',
          label: '品牌',
        },
      },
      {
        name: 'seriesName',
        columnProps: {
          prop: 'seriesName',
          label: '车系',
        },
      }, {
        name: 'modelName',
        columnProps: {
          prop: 'modelName',
          label: '车型',
        },
      }, {
        name: 'transactionCityName',
        columnProps: {
          prop: 'transactionCityName',
          label: '交车城市',
        },
      }, {
        name: 'financialInstitution',
        columnProps: {
          prop: 'financialInstitutionName',
          label: '金融机构',
        },
      }, {
        name: 'leaseModel',
        columnProps: {
          prop: 'leaseModelName',
          label: '租赁模式',
        },
      }, {
        name: 'repaymentMethod',
        columnProps: {
          prop: 'repaymentMethodName',
          label: '还款方式',
        },
      }, {
        name: 'unitPrice',
        columnProps: {
          prop: 'unitPrice',
          label: '车辆单价（元）',
        },
      }, {
        name: 'downPayment',
        columnProps: {
          prop: 'downPayment',
          label: '首付金额（元）',
        },
      }, {
        name: 'commission',
        columnProps: {
          prop: 'commission',
          label: '手续费（元）',
        },
      }, {
        name: 'leasePeriods',
        columnProps: {
          prop: 'leasePeriods',
          label: '租期',
        },
      }, {
        name: 'rent',
        columnProps: {
          prop: 'rent',
          label: '租金（元）',
        },
      }, {
        name: 'yearRate',
        columnProps: {
          prop: 'yearRate',
          label: '年利率',
        },
        getText: ({ row }) => (row.yearRate ? `${row.yearRate}%` : '--'),
      }, {
        name: 'operate',
        type: 'operate',
        columnProps: {
          label: '操作',
          fixed: 'right',
          width: 240,
        },
        maxShowLength: operateMaxShowLength,
        getOperateList: ({ row }) => {
          const result = []
          if (this.judgePermission('car_resource_center_detail')) {
            result.push({
              name: 'detail',
              label: '方案来源',
              action: () => this.goDetail(row),
            })
          }
          if (this.judgePermission('car_resource_center_earnings_calculation')) {
            result.push({
              name: 'calculate',
              label: '盈收测算',
              action: () => this.goCalculate(row.id),
            })
          }
          if (this.judgePermission('car_resource_message_add')) {
            result.push({
              name: 'cooperate',
              label: '合作咨询',
              action: () => this.showOperateDialog(row.id),
            })
          }
          return result
        },
      }],
      apiFn: getPlanList,
    },
    isShowDepartment: false,
  }
}

// 经租配置
export function economicLeaseConfigFn() {
  const ref = 'economicBaseListManagement'
  return {
    formData: {
      list: [{
        itemConfig: {
          prop: 'brandSeriesModel',
        },
        elConfig: {
          showModel: true,
        },
        render: 'CarBrandSeriesModel',
      }, {
        el: 'select',
        itemConfig: {
          label: '交车城市',
          prop: 'transactionCity',
        },
        elConfig: {
          clearable: true,
          options: {
            label: 'city',
            value: 'adcode',
            list: [],
          },
        },
      }],
      dealWithSearch: this.dealWithSearch,
      customizeReset: this.economicReset,
    },
    tableData: {
      columns: [{
        name: 'id',
        columnProps: {
          prop: 'id',
          label: '方案ID',
        },
      }, {
        name: 'title',
        columnProps: {
          prop: 'title',
          label: '方案名称',
          width: '160px',
        },
      }, {
        name: 'brandName',
        columnProps: {
          prop: 'brandName',
          label: '品牌',
        },
      }, {
        name: 'seriesName',
        columnProps: {
          prop: 'seriesName',
          label: '车系',
        },
      }, {
        name: 'modelName',
        columnProps: {
          prop: 'modelName',
          label: '车型',
        },
      }, {
        name: 'transactionCityName',
        columnProps: {
          prop: 'transactionCityName',
          label: '交车城市',
        },
      }, {
        name: 'leasePeriods',
        columnProps: {
          prop: 'leasePeriods',
          label: '租期',
        },
      }, {
        name: 'rent',
        columnProps: {
          prop: 'rent',
          label: '租金（元）',
        },
      }, {
        name: 'margin',
        columnProps: {
          prop: 'margin',
          label: '保证金/押金（元）',
        },
      }, {
        name: 'operate',
        type: 'operate',
        columnProps: {
          label: '操作',
          width: 240,
        },
        maxShowLength: operateMaxShowLength,
        getOperateList: ({ row }) => {
          const result = []
          if (this.judgePermission('car_resource_center_detail')) {
            result.push({
              name: 'detail',
              label: '方案来源',
              action: () => this.goDetail(row),
            })
          }
          if (this.judgePermission('car_resource_center_earnings_calculation')) {
            result.push({
              name: 'calculate',
              label: '盈收测算',
              action: () => this.goCalculate(row.id),
            })
          }
          if (this.judgePermission('car_resource_message_add')) {
            result.push({
              name: 'cooperate',
              label: '合作咨询',
              action: () => this.showOperateDialog(row.id),
            })
          }
          return result
        },
      }],
      apiFn: getPlanList,
    },
    isShowDepartment: false,
  }
}

// Tabs
export const TABS = {
  // 融租
  financialLease: 1,
  // 经租
  economicLease: 2,
}

// refs与config映射关系
export const REF_CONFIG = {
  financialBaseListManagement: 'financialLeaseConfig',
  economicBaseListManagement: 'economicLeaseConfig',
}

// TAB与ref映射关系
export const TAB_REF = {
  financialLease: 'financialBaseListManagement',
  economicLease: 'economicBaseListManagement',
}
